export default {
 gridConnectionValues: [
    '32 A',
    '40 A',
    '80 A'
  ]
};
